import { SelectItem } from 'primeng/api';

/**
 * 一般選項轉換
 * @param rawList 原始codetable物件陣列
 * @param labelName 欲設成下拉選單label的key
 * @param valueName 欲設成下拉選單value的key
 * @param transferMap 如需選項轉換時傳入之map(e.g. {T:true,F:false}原選項value為Ｔ轉換成true)
 * @returns SelectOptions[]
 */
const optionConvertCommon = (
  rawList: any[],
  labelName: any,
  valueName: any,
  transferMap?: Record<string | number, string | number | boolean>
) => {
  const tempList = [] as SelectItem[];
  rawList.forEach((option: { [x: string]: any }) => {
    const tempOption = {} as SelectItem;
    tempOption.label = option[labelName];
    if (transferMap) {
      tempOption.value =
        option[valueName] in transferMap
          ? transferMap[option[valueName]]
          : option[valueName];
    } else {
      tempOption.value = option[valueName];
    }
    tempList.push(tempOption);
  });

  return tempList;
};
/**
 * 選項轉換 顯示名稱:key+name
 * @param rawList 原始codetable物件陣列
 * @param labelName 欲設成下拉選單label的key
 * @param valueName 欲設成下拉選單value的key
 * @returns SelectOptions[]
 */
const optionConvertKeyCombineName = (
  rawList: any[],
  labelName: any,
  valueName: any,
  conjunction?: string
) => {
  const tempList = [] as SelectItem[];
  conjunction = conjunction ?? '.';
  rawList.forEach((option) => {
    const tempOption = {} as SelectItem;
    tempOption.label = option[valueName] + conjunction + option[labelName];
    tempOption.value = option[valueName];
    tempList.push(tempOption);
  });

  return tempList;
};

export { optionConvertCommon, optionConvertKeyCombineName };
